<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('company.modals.remove_claim_data.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
        :maskClosable="!processing"
        :closable="!processing"
    >
        <p>
            {{ $t('company.modals.remove_claim_data.content', { code: company_code }) }}
        </p>
        <ui-input v-model="confirm_text" />
        <template #footer>
            <a-button data-cy="cancel-button" type="default" key="cancel" @click="hideModal">
                {{ $t('company.modals.remove_claim_data.cancel') }}
            </a-button>
            <a-button
                key="submit"
                class="remove_button"
                type="danger"
                data-cy="admin-remove-company-claim"
                :loading="processing"
                @click="handleSubmit"
                :disabled="cannotProceed"
            >
                {{ $t('company.modals.remove_claim_data.submit') }}
            </a-button>
        </template>
    </a-modal>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';

export default {
    components: {
        UiInput,
    },
    data() {
        return {
            modal_visible: false,
            confirm_text: '',
        };
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
        company_code: {
            type: String,
            default: '',
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
        cannotProceed() {
            return this.company_code !== this.confirm_text || this.company_code.length === 0;
        },
    },
    methods: {
        showModal() {
            this.confirm_text = '';
            this.modal_visible = true;
        },
        hideModal() {
            this.modal_visible = false;
        },
        handleSubmit() {
            this.$emit('formSubmit', { claimsvault: true });
        },
    },
};
</script>
